export type UpdateAtomFunction<T> = (value: T) => T
export type SetAtom<T> = UpdateAtomFunction<T> | T

export enum AtomType {
    String = 'string',
    Number = 'number',
    Boolean = 'boolean',
    Object = 'object',
    Array = 'array'
}
